"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectScript = void 0;
exports.InjectScript = function (src) {
    var existingScript = document.querySelectorAll("head script[src=\"" + src + "\"]");
    if (existingScript.length > 0) {
        return new Promise(function (resolve, reject) {
            var script = existingScript[0];
            script.addEventListener("load", function () { return resolve(); });
            script.addEventListener("error", function () { return reject("Error loading script."); });
            script.addEventListener("abort", function () { return reject("Script loading aborted."); });
        });
    }
    return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.async = true;
        script.src = src;
        script.addEventListener("load", function () { return resolve(); });
        script.addEventListener("error", function () { return reject("Error loading script."); });
        script.addEventListener("abort", function () { return reject("Script loading aborted."); });
        document.head.appendChild(script);
    });
};
//# sourceMappingURL=inject-script.js.map